// extracted by mini-css-extract-plugin
module.exports =  {"content":"JsJVNJPvZSXJpcpB36Z7","details":"fmI03qKqgwwdUYewALyQ","detail":"GRLzea3x86SPzGAlJaD4","label":"ayW4RTTWcW6kiTOJZemt","buttonWrapper":"MvMZZlj8z6nMoRwyz0pr"};